const listOfCriteriaComponent = () =>
  import("@/views/bulkNotification/listOfCriteria.vue");
const manageNotification = () =>
  import("@/views/bulkNotification/manageNotification");
const updateManageNotification = () =>
  import("@/views/bulkNotification/updateManageNotification");

export default {
  path: "listOfCriteria",
  name: "List of Criteria",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      meta: {
        requiresAuth: true,
      },
      component: listOfCriteriaComponent,
    },
    {
      path: "manageNotification",
      name: "Manage Notification",
      meta: {
        requiresAuth: true,
      },
      component: manageNotification,
    },
    {
      name: "Update Manage Notification",
      path: "updateManageNotification/:id",
      meta: {
        requiresAuth: true,
      },
      component: updateManageNotification,
    },
  ],
};
